import { isFeature } from 'Cloud/Application/FeaturesEs6';

/** CLOUDWEB-18801 Закрывать ли просмоторщик при браузерной навигации */
export const shouldCloseAttachViewerOnNavigation = isFeature('close-attach-viewer-on-navigation');
